var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1203 13.1228H3.66667C3.16041 13.1228 2.75 12.7311 2.75 12.2478V8.74785C2.75 8.2646 3.16041 7.87285 3.66667 7.87285H5.1203L9.43515 3.75413C10.0126 3.20291 11 3.59331 11 4.37285V16.6228C11 17.4024 10.0126 17.7928 9.43515 17.2416L5.1203 13.1228Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2409 7.40422C16.0308 9.11276 16.0308 11.8829 14.2409 13.5914M16.8337 4.92929C20.0555 8.00467 20.0555 12.9908 16.8337 16.0662M5.1203 13.1228H3.66667C3.16041 13.1228 2.75 12.7311 2.75 12.2478V8.74785C2.75 8.2646 3.16041 7.87285 3.66667 7.87285H5.1203L9.43515 3.75413C10.0126 3.20291 11 3.59331 11 4.37285V16.6228C11 17.4024 10.0126 17.7928 9.43515 17.2416L5.1203 13.1228Z",
    stroke: "#6B7280",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume-up.a2570ab2b6ba039c46c451ee9be90116.svg";
export { ForwardRef as ReactComponent };